/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

import { data, type ObservableValue } from '@amazon/vinyl-observable'
import { globalRef } from '@amazon/vinyl-util'
import { ONBOARDING_PREFIX } from '@/router/onboardingPrefix'
import { onNavigate } from '@/router/router'

const CHROMELESS_ROUTE_PREFIXES: readonly string[] = [ONBOARDING_PREFIX]

/** Whether `pathname` belongs to a flow that renders without the header, transport and banners. */
export function isChromelessRoute(pathname: string): boolean {
    return CHROMELESS_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix))
}

const chromelessRef = globalRef(() => data(isChromelessRoute(window.location.pathname || '/')))

// Module-level subscription, matches the shell lifetime.
onNavigate((event) => {
    chromelessRef.value.value = isChromelessRoute(event.current)
})

export const chromelessRoute$: ObservableValue<boolean> = chromelessRef.value
